module.exports = __webpack_public_path__ + "img/historicalPlans-x.4c2b50bd.svg";